import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const ConsultingProducts = {
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),
  ProductsList: lazyNamed(() => import('./containers/ProductsList/index.tsx'), 'ProductsList'),
  ProductForm: lazyNamed(() => import('./containers/ProductForm/index.tsx'), 'ProductForm'),
  AdMediaList: lazyNamed(() => import('./containers/AdMediaList/index.tsx'), 'AdMediaList'),
  AdMediaHistory: lazyNamed(() => import('./containers/AdMediaHistory/index.tsx'), 'AdMediaHistory'),
  PlacementsList: lazyNamed(() => import('./containers/PlacementsList/index.tsx'), 'PlacementsList'),
  PlacementHistory: lazyNamed(() => import('./containers/PlacementHistory/index.tsx'), 'PlacementHistory'),
  AdTypesList: lazyNamed(() => import('./containers/AdTypesList/index.tsx'), 'AdTypesList'),
  AdTypeHistory: lazyNamed(() => import('./containers/AdTypeHistory/index.tsx'), 'AdTypeHistory'),
  AdPricesList: lazyNamed(() => import('./containers/AdPricesList/index.tsx'), 'AdPricesList'),
  AdPriceForm: lazyNamed(() => import('./containers/AdPriceForm/index.tsx'), 'AdPriceForm'),
  AdPriceHistory: lazyNamed(() => import('./containers/AdPriceHistory/index.tsx'), 'AdPriceHistory'),
  ProductHistory: lazyNamed(() => import('./containers/ProductHistory/index.tsx'), 'ProductHistory'),
};
